import {Component, Input} from '@angular/core';
import {SavedReportComponentObject} from '../../../../../shared/classes/saved-report-component-object';
import {Observable, of} from "rxjs";
import {map} from "rxjs/operators";
import {AdRReportParameter, AdRReportType} from "../../../../../shared/interfaces/ad-reports";

@Component({
  selector: 'app-report-table-row-parameters',
  templateUrl: './report-table-row-parameters.component.html',
  styleUrls: ['./report-table-row-parameters.component.scss']
})
export class ReportTableRowParametersComponent {
  public report: SavedReportComponentObject;

  @Input('report') private set _init(report: SavedReportComponentObject) {
    this.report = report;

    if (report) {
      this.parameters = report.parameters$.pipe(
        map(parameters => this.order.reduce((output: Array<{ type: string, parameter: any }>, item: AdRReportParameter) => {
          if (this.reportsParameters[report.payload.attributes.report_type].includes(item)) {
            output.push({
              type: item,
              parameter: parameters[item]
            });
          }

          return output;
        }, []))
      );
    }
  };

  public readonly order: Array<AdRReportParameter> = [
    'dimensions',
    'metrics',
    'conversion_metric',
    'channel',
    'period',
    'filters'
  ];

  public readonly reportsParameters: Partial<Record<AdRReportType, AdRReportParameter[]>> = {
    'dashboard': ['period', 'filters'],
    'performance': ['dimensions', 'metrics', 'period', 'filters'],
    'cycle': ['dimensions', 'conversion_metric', 'period', 'filters'],
    'graph': ['dimensions', 'metrics', 'period', 'filters'],
    'chart': ['dimensions', 'metrics', 'period', 'filters'],
    'affinity': ['conversion_metric', 'channel', 'period', 'filters'],
    'transaction-id': ['conversion_metric', 'channel', 'period', 'filters'],
    'path-explorer': ['conversion_metric', 'period']
  };

  public parameters: Observable<Array<{ type: string, parameter: any }>> = of([]);
}
